import info from './info'
import menu from './menu'
import table from './table'
import userFilters from './userFilters'

export default {
    userId: 'Nutzer {id}',
    newUser: 'Neuer Nutzer',
    createUser: 'Neuen Nutzer anlegen',

    deleteUser: 'Nutzer löschen',
    deleteUserText:
        'Möchtest du den Nutzer wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    deleteOtherUserText:
        'Möchtest du den Nutzer {name} wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    deleteOwnUserText:
        'Möchtest du deinen Account wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
    transferDataText: "Angelegte Vorgänge & Formulare müssen auf einen Nutzer mit der gleichen Organisation übertragen werden. Bitte wähle einen Nutzer aus.",
    noSelectableUsers: 'Es gibt keine Nutzer, die du auswählen kannst. Mögliche Ursachen sind:\n- Es gibt keinen anderen Nutzer in dieser Organisation.\n- Du hast mit der aktuellen Rolle keine Berechtigung, um andere Nutzer aus dieser Organisation zu sehen.',
    deleteUserSuccess: 'Nutzer wurde erfolgreich gelöscht.',
    deleteUserError: 'Der Nutzer konnte nicht gelöscht werden.',
    userDeleteInfoError: 'Die Nutzer zur Übertragung konnten nicht geladen werden',

    resendEmailVerificationMailSuccess: 'Verifizierungsmail wurde erfolgreich versendet.',
    resendEmailVerificationMailError: 'Verifizierungsmail konnte nicht versendet werden.',
    impersonateSuccess: 'Erfolgreich als gewählter Nutzer unterwegs.',
    impersonateError: 'Identität konnte nicht übernommen werden.',
    impersonateBanner: 'Als {fullname} {organisation_name} unterwegs.',
    leaveImpersonationSuccess: 'Identität wurde erfolgreich zurückgesetzt.',
    leaveImpersonationError: 'Identität konnte nicht zurückgesetzt werden.',
    leaveImpersonationLink: 'Zurück',
    updateSuccess: 'Nutzer wurde erfolgreich gespeichert',
    saveSuccess: 'Nutzer wurde erfolgreich gespeichert',
    welcome: 'Willkommen {name}!',

    generatedReports: {
        description: 'Deine zuletzt erzeugten Auswertungen stehen hier {days} Tage lang zum erneuten Download bereit. Danach werden sie automatisch gelöscht; die Auswertung lässt sich jederzeit neu erzeugen.',
        refresh: 'Aktualisieren',
        empty: 'Es liegen derzeit keine Auswertungen zum Download bereit.',
        download: 'Herunterladen',
        unknownReport: 'Auswertung',
        processCount: '{count} Vorgänge',
        failedHint: 'Die Erzeugung ist fehlgeschlagen. Bitte erzeuge die Auswertung erneut.',
        loadError: 'Die Auswertungen konnten nicht geladen werden.',
        downloadError: 'Die Datei konnte nicht heruntergeladen werden.',
        liveDownloadFailedTitle: 'Automatischer Download nicht möglich',
        liveDownloadFailedText: 'Die Auswertung wurde erzeugt und liegt in deinem Profil unter „Meine Auswertungen" zum Download bereit.',
        liveDownloadInvalid: 'Die Auswertung konnte nicht erzeugt werden, da die Anfrage fehlerhaft war.',
        status: {
            pending: 'Wird erstellt',
            failed: 'Fehlgeschlagen',
            done: 'Fertig',
        },
    },

    firstname: 'Vorname',
    lastname: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    profileImage: 'Profilbild',
    profile_image_id: 'Profilbild ID',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    current_organisation_id: 'Aktive Organisation',

    sportBizzUser: 'Sport-Nutzer',
    sportBizzUserDescription: 'Da sich dieser Nutzer über die Sport-Schnittstelle anmeldet, können die Daten hier in oaseBW nicht bearbeitet werden. Bei Support-Anfragen nenne bitte die SportBizz-ID "{sportBizzId}" und den SportBizz-Usernamen "{sportBizzUsername}".',

    signatureInfo: 'Mit dieser Unterschrift können Sammellisten, die bei der Auswertung erstellt werden, unterschrieben werden.',
    createSignature: 'Signatur erstellen',
    signed_at: 'Unterschrieben am {date}',

    acceptSignature: {
        title: 'Digitale Unterschrift',
        description: 'Unterschreibe direkt hier in der App.',
        sign: 'Weitergabevertrag unterschreiben',
        scanQrCode: 'Scanne den QR-Code um zu unterschreiben.',
        missingScanningDevice: 'Kein Gerät zum einscannen?',
        signOnThisDevice: 'Auf diesem Gerät unterschreiben'
    },

    signatureTitle: 'Unterschrift',

    deleteSignature: 'Unterschrift löschen',
    deleteSignatureText: 'Möchtest du die Unterschrift wirklich löschen?',
    deleteSignatureSuccess: 'Die Unterschrift wurde erfolgreich gelöscht.',
    deleteSignatureError: 'Die Unterschrift konnte nicht gelöscht werden.',


    organisation_id: 'Verknüpfte Organisation',
    user_id: 'Verknüpfter Nutzer',
    role_name: 'Verknüpfte Rolle',
    organisation_user_id: 'Verknüpfung',
    amos_web_connection_active: 'amosWEB Verbindung aktiv',

    confirmLeave: 'Du hast nicht gespeicherte Änderungen. Möchtest du die Seite wirklich verlassen?',

    info,
    menu,
    table,
    userFilters,
}